import { render, staticRenderFns } from "./CustomerLogsTable.vue?vue&type=template&id=23165d6a"
import script from "./CustomerLogsTable.vue?vue&type=script&lang=js"
export * from "./CustomerLogsTable.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CustomerLogsTable.vue?vue&type=style&index=1&id=23165d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports